<template>
    <block-sidebar title="Ricerca Avanzata">
        <template v-slot:icon>
            <font-awesome-icon :icon="['fad', 'search']"></font-awesome-icon>
        </template>

        <div class="btn-group btn-block">
            <btn
                type="success"
                block
                :action="submitFilter"
                title="Applica"
            ></btn>
            <btn
                type="danger"
                block
                light
                :action="resetFilter"
                title="Reset"
            ></btn>
        </div>

        <datatable-filter-single
            v-for="(value, colIndex) in thead"
            :ref="'filter_' + colIndex"
            :key="colIndex"
            :ref-table="refTable"
            :col="value"
            :params="params"
        ></datatable-filter-single>

        <div class="btn-group btn-block">
            <btn
                type="success"
                block
                :action="submitFilter"
                title="Applica"
            ></btn>
            <btn
                type="danger"
                block
                light
                :action="resetFilter"
                title="Reset"
            ></btn>
        </div>
    </block-sidebar>
</template>

<script>
export default {
    data: () => ({
        thead: null,
        params: []
    }),
    props: {
        refTable: {
            type: String,
            default: "",
            required: true
        },
        refMap: {
            type: String,
            default: "",
            required: false
        }
    },
    mounted: function() {
        if (typeof this.getTable !== "undefined")
            this.thead = this.getTable.thead;
        if (typeof this.getTable !== "undefined")
            this.params = this.getTable.search.params;
    },
    computed: {
        getTable: function() {
            return this.$root.$refs[this.refTable];
        }
    },
    methods: {
        getFilters: function() {
            return Object.keys(this.$refs).filter(element =>
                element.toUpperCase().indexOf("FILTER_") !== -1 ? true : false
            );
        },
        submitFilter: function() {
            this.$root.filterTable(this.refTable, this.refMap);
        },
        resetFilter: function() {
            let filters = this.getFilters();

            for (let index = 0; index < filters.length; index++) {
                if (typeof this.$refs[filters[index]] === "undefined") continue;

                if (
                    typeof this.$refs[filters[index]][0] !== "undefined" &&
                    this.$refs[filters[index]][0].reset instanceof Function
                )
                    this.$refs[filters[index]][0].reset();
                else if (this.$refs[filters[index]].reset instanceof Function)
                    this.$refs[filters[index]].reset();
            }

            this.$root.resetFilterTable(this.refTable);
        }
    }
};
</script>
